<template>
  <div class="ind-container indyvit-text">
    <!-- <div class="font-roc-grotesk-light">indyvit</div> -->
    <div
      class="name-text"
      v-html="$t('scene_productdetails.text_individual_sup', { name: name })"
    ></div>
    <div>{{ total }} {{ currencySymbol }}</div>
  </div>
</template>

<script>
export default {
  props: {
    name: String,
    total: Number,
    currencySymbol: String,
  },
};
</script>

<style>
.name-text {
  margin-bottom: 10px;
}

.ind-container {
  display: flex;
  flex-direction: column;
  align-items: start;
  margin-bottom: 10px;
}

.indyvit-text {
  font-size: 1.7em;
  color: #000;
}

.highlight {
  font-size: 2.5em; /* Größere Schriftgröße */
  color: #000;
  text-align: start; /* Zentriert den Namen */
  font-family: "Roc Grotesk Medium", sans-serif; /* Ändert die Schriftart */
  line-height: 1;
}

.subtitle {
  font-size: 1em;
  color: #000; /* Beispiel: Grauer Untertitel */
  display: block; /* Erzwingt, dass der Untertitel auf einer separaten Zeile steht */
  text-align: start; /* Zentriert den Untertitel */
  font-family: "Roc Grotesk Light", sans-serif; /* Ändert die Schriftart */
}
</style>
